/**
 * created by li si yi
 * 平台日志
 */
import React, {Component} from 'react';
import {Input, Select, Button, DatePicker, Pagination, Modal, Empty} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import BaseComponent from "../../../base/BaseComponent";
import moment from "moment";

const {RangePicker} = DatePicker;
const {Search} = Input;
const {Option} = Select;
export default class SysLog extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            logInfo: '',
            userAccount: '',
            type: '0',
            operation: '0',
            startTime: null,
            endTime: null,
            dataList: [],
            count: 0,
            everyList: [],
            currentCount: 0,
            columns: [
                {
                    title: '日志类型',
                    dataIndex: 'logType',
                    key: 'logType',
                    width: '100px',
                    render: (text) => {
                        return (
                            <div style={{display: 'flex'}}>
                                <div style={{marginLeft: '8px'}}>{text}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '账号',
                    dataIndex: 'account',
                    ellipsis: true,
                    width: '100px',
                    key: 'account',
                    render: (text) => {
                        return (
                            <span>{text}</span>
                        )
                    }
                },
                {
                    title: '操作时间',
                    dataIndex: 'logTime',
                    key: 'logTime',
                    ellipsis: true,
                    width: '160px',
                    render: (text) => {
                        return (
                            <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                        )
                    }
                },
                {
                    title: '操作描述',
                    dataIndex: 'message',
                    ellipsis: true,
                    key: 'message',
                    width: '250px',
                    render: (text) => {
                        return (
                            <span>{text}</span>
                        )
                    }
                },
                {
                    title: '调用位置',
                    dataIndex: 'location',
                    ellipsis: true,
                    width: '250px',
                    key: 'location',
                    render: (text) => {
                        return (
                            <span>{text}</span>
                        )
                    }
                },
            ],
            params: {
                start: 1,//分页
                size: 10,
                logType: "",//日志类型
                message: "",//日志内容
                startTime: "",//开始时间
                endTime: "",//结束时间
                account: ''
            },
            total: 0,//总数
            dataSource: [//列表数据
            ],
            thisType: ''
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
        // this.getList();
    }

    getList() {
        let {params} = this.state;
        let startTime = params.startTime ? new Date(params.startTime.format('YYYY-MM-DD') + ' 00:00:00').getTime() : null;//YYYY-MM-DD HH:mm:ss
        let endTime = params.endTime ? new Date(params.endTime.format('YYYY-MM-DD') + ' 23:59:59').getTime() : null;
        this.setState({
            params: {
                ...this.state.params,
                startTime,
                endTime
            }
        }, () => {
            this.getDataSource();
        });
    }

    render() {
        return (
            <div style={{margin: "15px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    maxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    // overflow: 'hidden',
                    paddingTop: 24
                }}>
                    <div style={{padding: '0px 32px 24px'}}>
                        {this.renderHeader()}
                    </div>
                    {this.renderContent()}
                </div>
                {this.renderModal()}
            </div>
        )
    }

    // 头部
    renderHeader() {
        return (
            <div style={{display: 'flex'}}>
                <div>
                    <Select value={this.state.thisType} style={{width: 120}}
                            onChange={(val) => this.handleChangeType(val)}>
                        <Option value={''}>不限类型</Option>
                        <Option value={'INFO'}>提示日志</Option>
                        <Option value={'ERROR'}>错误日志</Option>
                        <Option value={'DEBUG'}>调试日志</Option>
                    </Select>
                </div>
                <div style={{marginLeft: 20}}>
                    <Search
                        placeholder="搜索账号"
                        value={this.state.userAccount}
                        onChange={(e) => {
                            this.setState({userAccount: e.target.value})
                        }}
                        onSearch={value => this.userIdOnSearch(value)}
                        style={{width: 200}}
                    />
                </div>
                <div style={{marginLeft: 20}}>
                    <Search
                        placeholder="请输入操作描述"
                        value={this.state.logInfo}
                        onChange={(e) => {
                            this.setState({logInfo: e.target.value})
                        }}
                        onSearch={value => this.messageOnSearch(value)}
                        style={{width: 200}}
                    />
                </div>
                <div style={{marginLeft: 20}}>
                    <RangePicker value={[this.state.startTime, this.state.endTime]}
                                 format={"YYYY-MM-DD"}
                                 onChange={(date, dateString) => {
                                     this.state.startTime = date[0];
                                     this.state.endTime = date[1];
                                     this.state.params.startTime = date[0];
                                     this.state.params.endTime = date[1];
                                     this.state.params.start = 1;

                                     this.getList();
                                 }}/>
                </div>
                <Button style={{marginLeft: 20}} type="primary" onClick={() => this.revert()}>重置</Button>
            </div>
        )
    }

    //内容
    renderContent() {

        console.log("this.state.dataSource：  ", this.state.dataSource);

        return (
            <div>
                <div style={{maxHeight: 'calc(100vh - 246px)', padding: '0px 32px'}} className={"sysLog"}>
                    <Scrollbars autoHeight autoHeightMax={"calc(100vh - 246px)"}>
                        <BaseTable
                            rowKey="id"
                            dataSource={this.state.dataSource}
                            // titleKeyList={titleKeyList}
                            columns={this.state.columns}
                            //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                            pagination={false}
                            onRow={(record, index) => {
                                return {
                                    onClick: event => {
                                        // console.log('onclickItem', record, index)
                                    }, // 点击行
                                    onDoubleClick: event => {
                                    },
                                    onContextMenu: event => {
                                    },
                                    onMouseEnter: event => {
                                    }, // 鼠标移入行
                                    onMouseLeave: event => {
                                    },
                                };
                            }}
                            // locale={{emptyText: '暂无数据'}}
                        />
                    </Scrollbars>
                    <style>{`
                            .sysLog .ant-table-placeholder{
                               display:flex;
                               justify-content: center;
                               align-items: center;
                               height:545px;
                               border:none;
                            }
                        `}</style>
                </div>
                {this.state.dataSource.length ? this.renderFooter() : null}
            </div>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        // 获取当前tab参数
        let {start, size} = params;
        return (
            <div className={'pagination'} style={{paddingBottom: "17px",paddingTop: "17px"}}>
                <div style={{padding: "0 10px 0"}}>共{total}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    renderModal() {
        let titleKeyList = [
            {
                key: 'fileName',
                titleName: '名称',
                width: 300,
                align: 'left',
            },
            {
                key: 'fileUrl',
                titleName: '操作',
                width: '20%',
                render: (text, record, index) => {
                    return (<div>
                            <Button onClick={() => {
                                window.location.href = "/cm-sites-" + process.env.REACT_APP_NAME + record.fileUrl + "?download=1"
                            }}>下载</Button>
                        </div>

                    )
                }
            },];
        return (
            <Modal
                title="每日列表"
                visible={this.state.visible}
                onOk={() => {
                }}
                onCancel={() => {
                    this.setState({visible: false})
                }}
                footer={null}
            >
                <div style={{height: 550}}>
                    <div style={{height: 500}}>
                        <Scrollbars>
                            <BaseTable
                                dataSource={this.state.dataList}
                                titleKeyList={titleKeyList}
                                //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                                pagination={false}
                                onRow={(record, index) => {
                                    return {
                                        onClick: event => {
                                            // console.log('onclickItem', record, index)
                                        }, // 点击行
                                        onDoubleClick: event => {
                                        },
                                        onContextMenu: event => {
                                        },
                                        onMouseEnter: event => {
                                        }, // 鼠标移入行
                                        onMouseLeave: event => {
                                        },
                                    };
                                }}
                                locale={{emptyText: '暂无数据'}}
                                columns={this.state.columns}
                            />
                        </Scrollbars>
                    </div>
                </div>
            </Modal>
        )
    }

    //获取列表数据
    getDataSource = () => {
        let {params} = this.state;
        this.request({
            url: '/cm-sites-sys/mongoLog/findPageList',
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({dataSource, total})
            }
        })
    };

    //分页
    pageChange(page, pageSize) {
        let {params} = this.state;
        params.start = page;
        params.size = pageSize;
        this.getDataSource();
    }

    //类型
    handleChangeType = (val) => {
        let {params} = this.state;
        params.start = 1;
        this.setState({
            thisType: val,
        });
        params.logType = val;
        this.getDataSource();
    };

    //搜索
    userIdOnSearch(value) {
        // console.log(value);
        let {params} = this.state;
        params.account = value;
        params.start = 1;
        this.getDataSource();
    }

    messageOnSearch(value) {
        // console.log(value);
        let {params} = this.state;
        params.message = value;
        params.start = 1;
        this.getDataSource();
    }

    //重置按钮
    revert() {
        this.state.params = {
            start: 1,//分页
            size: 10,
            logType: "",//日志类型
            message: "",//日志内容
            startTime: "",//开始时间
            endTime: "",//结束时间
            account: ''
        };
        this.setState({
            thisType: '',
            logInfo: '',
            userAccount: '',
            startTime: null,
            endTime: null,
        });
        this.getDataSource()
    }

    getEveryDay() {
        let body = {
            start: this.state.currentPage,
            size: this.state.currentPageSize
        }
    }

    exportExcel() {
        let startTime = this.state.startTime ? this.state.startTime.format('YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endTime = this.state.endTime ? this.state.endTime.format('YYYY-MM-DD') + ' 23:59:59' : null;
        let body = {
            pageNum: this.state.currentPage,
            pageSize: this.state.currentPageSize,
            type: this.state.type,
            operation: this.state.operation,
        };
        if (startTime) {
            body.startTime = new Date(startTime).getTime();
            body.endTime = new Date(endTime).getTime();
        }
        if (this.state.logInfo) {
            body.logInfo = this.state.logInfo;
        }
        if (this.state.userAccount) {
            body.userAccount = this.state.userAccount;
        }
    }
}